import { render, staticRenderFns } from "./EmployeeIdentification.vue?vue&type=template&id=6281b822"
import script from "./EmployeeIdentification.vue?vue&type=script&lang=js"
export * from "./EmployeeIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports